import React, { Component } from 'react';
import * as coordinateFormatter from '@arcgis/core/geometry/coordinateFormatter';
import Graphic from '@arcgis/core/Graphic';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import ArcGISMap from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import BasemapToggle from '@arcgis/core/widgets/BasemapToggle';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import Search from '@arcgis/core/widgets/Search';
import { getMapExtent } from '../esri/mapHub';
import symbols from '../../defaults/Symbols.json'

export class NewIncidentMap extends Component
{
  constructor(props)
  {
     super(props);
     this.state =
     {
       mapIsLoaded: false,
       userLatitude: null,
       userLongitude: null,
       manualLat: props.manualLat,
       manualLong: props.manualLong
     };

      this.mapRef = React.createRef();
   }

    componentDidMount()
   {
     this.startup();
   }

   componentWillReceiveProps(nextProps)
   {
     if(!this.state.mapIsLoaded && nextProps.open && !this.props.open)
     {
       this.startup();
     }

     if(nextProps.manualLat !== this.state.manualLat || nextProps.manualLong !== this.state.manualLong)
     {
       this.updatePoint(nextProps.manualLat, nextProps.manualLong);
     }
   }

   shouldComponentUpdate(nextProps, nextState)
   {
     return false;
   }

   componentWillUnmount()
   {
     // Clean up jsapi's dirty little mess
   }

   render()
   {
     return (
       <div className="webmap" ref={this.mapRef}></div>
     );
   }

   updatePoint = (manualLat, manualLong) =>
   {
     if (manualLat === this.state.userLatitude && manualLong === this.state.userLongitude)
     {
       return;
     }

     // Load dependencies of "coordinateFormatter" module
     coordinateFormatter.load().then(() =>
     {
       var newPoint = coordinateFormatter.fromLatitudeLongitude(manualLat + " " + manualLong);

       this.setState({
         userLatitude: manualLat,
         userLongitude: manualLong
       });

       this.props.onCoordinateUpdate(manualLat, manualLong);

       this.originGraphicsLayer.removeAll();

       this.originGraphicsLayer.graphics.add(
         new Graphic(
           {
             geometry: newPoint,
             symbol:  new SimpleMarkerSymbol(symbols.newIncidentSymbol)
           })
       );

       this.view.center = newPoint;
       console.log(newPoint);

    });
   }

  startup = () =>
  {
   const map = new ArcGISMap({
     basemap: 'topo-vector'
   });

   this.view = new MapView({
     container: this.mapRef.current,
     map: map,
     center: [-118, 34],
     zoom: 8
   });

   this.basemapToggle = new BasemapToggle({
      view: this.view
    });

   this.map = this.view.map;
   this.view.ui.add(this.basemapToggle, 'bottom-right');

   let originGraphicsLayer = new GraphicsLayer();
   map.add(originGraphicsLayer);
   this.originGraphicsLayer = originGraphicsLayer;

   //Set map extent to main map extent
   getMapExtent().then(
    result =>
      {
        this.view.extent = result;
      }
    );

  //handler to move new incident graphic to user click point
  this.view.on("click", (event) =>
  {
    this.setState({
      userLatitude: event.mapPoint.latitude,
      userLongitude: event.mapPoint.longitude
    });

    this.props.onCoordinateUpdate(event.mapPoint.latitude, event.mapPoint.longitude);

    this.originGraphicsLayer.removeAll();

    this.originGraphicsLayer.graphics.add(
      new Graphic(
        {
          geometry: event.mapPoint,
          symbol:  new SimpleMarkerSymbol(symbols.newIncidentSymbol)
        })
      );
    });

      let search = new Search();
      this.view.ui.add(search, {
        position: "top-right"
      });

      this.search = search;

      this.search.on('select-result', (event) => {
        this.view.extent = event.result.extent.extent;
      });

   this.setState({
     mapIsLoaded: true
   });

 }
}

export default NewIncidentMap;
